import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalWizardComponent, ModalWizardPageComponent, ScApiService, ScUploadService } from '@sc-ui';
import { Subject } from 'rxjs';
import { LabelType, Options } from "@angular-slider/ngx-slider";
import { texts } from './modal-create-project.texts';

@Component({
  standalone: false,
  selector: 'app-modal-create-project',
  templateUrl: './modal-create-project.component.html',
  styleUrls: ['./modal-create-project.component.scss']
})
export class ModalCreateProjectComponent {

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  @ViewChild('modal')
  modal: ModalWizardComponent;

  @ViewChild('sourcePage')
  sourcePage: ModalWizardPageComponent;

  @ViewChild('loadingPage')
  loadingPage: ModalWizardPageComponent;

  @ViewChild('loadingErrorPage')
  loadingErrorPage: ModalWizardPageComponent;

  project: any;

  errors: any = [];

  isSending = false;

  onResult: any;

  parseSuccess = false;

  parseError = "";

  postUri: any;

  postText: any;

  isUploading = false;

  file: any = null;

  uploadError: any;

  constructor(private api: ScApiService, private uploadService: ScUploadService, private router: Router) { }

  start() {
    this.onResult = new Subject<any>();
    this.modal.show(this.sourcePage);
    return this.onResult;
  }
  
  upload(selectedFiles) {

    if (selectedFiles.length < 1) return;
    if (this.isUploading || this.isSending) return;
    const fileToUpload = selectedFiles[0];

    this.isUploading = true;

    this.uploadService.upload(
      selectedFiles,
      (res: any) => {

        this.isUploading = false;
        this.postUri = res.Uri;

        this.file = {
          Uri: res.Uri,
          Name: fileToUpload.name,
          Size: fileToUpload.size
        };

        this.createProject();
      },
      (percentage: number) => { },
      (error: any) => {
        this.uploadError = error.message;
        this.isUploading = false;
      }
    );
  }

  createProject() {

    // parsing a post takes a while, so without this a second click (or a retry
    // after a timeout) creates a second project
    if (this.isSending) return;
    this.isSending = true;

    var args = {
      PostUri: this.postUri,
      PostText: this.postText
    };

    this.modal.navigateTo(this.loadingPage);

    this.api.post('projects', args).subscribe({

      next: (d: any) => {

        this.isSending = false;
        this.project = d.Project;

        if (d.Success)
        {        
          this.modal.dismiss();
          this.navigateToProject();
        }
        else
        {
          this.parseSuccess = false;
          this.parseError = d.Error;
          this.modal.navigateTo(this.loadingErrorPage);
        }      
      },

      error: (e: any) => {

        this.isSending = false;
        this.parseSuccess = false;
        this.parseError = e?.message;
        this.modal.navigateTo(this.loadingErrorPage);
      }
    });
  }

  restart() {
    this.project = null;
    this.modal.navigateTo(this.sourcePage, 'none');

  }

  navigateToProject() {
    this.modal.dismiss();
    this.router.navigateByUrl('/projects/' + this.project.Id);
  }
}
